import { ILocation } from 'src/types/Location';

export const MAX_LOCATIONS_ALLOWED = 15;

export const transformLocationsToIds = (
  locations: ILocation[] = []
): string[] => locations.map((loc) => loc.id);
